const enUS = {
    crossmintPayButtonService: {
        CONNECTING: "Connecting...",
        BUY: "Buy with Crossmint",
        BUY_WITH_ETH: "Buy with ETH",
        BUY_WITH_SOL: "Buy with SOL",
        BUY_WITH_CREDIT_CARD: "Buy with credit card",
    },
};
export default enUS;
